import { ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C45HighlightedQuoteProps = RenderingProps<
  C45HighlightedQuoteFields,
  C45HighlightedQuoteParams
>;

export type C45HighlightedQuoteFields = {
  Quote?: RichTextField;
  Image?: ImageField;
  Byline?: RichTextField;
  Cta?: LinkField;
};

export type C45HighlightedQuoteParams = {
  BackgroundColor?: string;
  CtaStyle?: string;
  ContentAlignment?: string;
} & TranslationOptionsParams &
  AnchorTargetParams;
